import { useEffect } from 'react';
import { useMyBookingsStore } from '../../../../domain/booking/stores/useMyBookingsStore';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';

export function useSaveBookingOnSignUpSuccess(success: boolean) {
	const myBookingsStore = useMyBookingsStore();
	const newBookingStore = useNewBookingStore();

	useEffect(() => {
		if (!success) {
			return;
		}

		const { reference, personalDetails } = newBookingStore.booking;

		if (!reference || !personalDetails?.email) {
			throw new Error('Invalid booking details');
		}

		myBookingsStore.addGuestBooking({
			reference,
			email: personalDetails?.email,
		});
	}, [success]);
}
